import Component from '../abstracts/Component';
import vex from 'vex-js';

export default class PdpPremiumPackagingComponent extends Component {

  get SELECTORS() {
    return {
      btn: '[data-packaging-btn]',
      layer: '[data-packaging-layer]',
      modalLayer: '.vex [data-packaging-layer-content]',
      modalClose: '.vex [data-modal-close]',
      modalWrapper: '.vex.pdp-packaging-modal'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.btn = this.$component.querySelector(this.SELECTORS.btn);
  }

  modalClose(vexInstance) {
    const closeBtn = document.querySelector(this.SELECTORS.modalClose);
    if (closeBtn) {
      closeBtn.addEventListener('click', () => vex.close(vexInstance));
    }
  }

  readModalElem() {
    this.layer = document.querySelector(this.SELECTORS.modalLayer);
    this.modalWrapper = document.querySelector(this.SELECTORS.modalWrapper);
  }

  bindEvents() {
    const ctx = this;
    this.btn.addEventListener('click', () => {
      const content = document.querySelector(this.SELECTORS.layer).innerHTML;

      vex.open({
        unsafeContent: content,
        className: 'pdp-packaging-modal compact',
        overlayClassName: 'pdp-packaging-modal__overlay',
        showCloseButton: false,
        afterOpen() {
          ctx.readModalElem();
          ctx.modalClose(this);
        }
      });
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
